import ApiService from "@/api.service";
import API from "@/API";

export const GET_LIST_SUPPORT = "listSupport";
export const GET_DETAIL_SUPPORT = "detailSupport";
export const SAVE_SUPPORT = "saveSupport";
export const UPDATE_SUPPORT = "updateSupport";
export const DELETE_SUPPORT = "deleteSupport";
export const UPLOAD_AVATAR_SUPPORT = "uploadSupport";
export const GET_DATA_SEARCH = "getDataSearchSupport";
export const SET_DATA_SEARCH = "setDataSearchSupport";

export const SET_LIST_SUPPORT = "setListSupport";
export const SET_DETAIL_SUPPORT = "setDetailSupport";


const state = {
    supports: [],
    support: {},
    dataSearchSupport: [],
};

const getters = {
    supports(state) {
        return state.supports;
    },
    support(state) {
        return state.support;
    },
    dataSearchSupport(state) {
        return state.dataSearchSupport;
    },
};

const actions = {
    [UPLOAD_AVATAR_SUPPORT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.UPLOAD_AVATAR_SUPPORT}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [GET_LIST_SUPPORT](context) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_SUPPORT).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_LIST_SUPPORT, data);
                }
                resolve(data);
            });
        });
    },
    [GET_DETAIL_SUPPORT](context, id) {
    return new Promise(resolve => {
    ApiService.query(`${API.GET_DETAIL_SUPPORT}/${id}`).then(({data}) => {
    if (data.status) {
    context.commit(SET_DETAIL_SUPPORT, data);
    }
    resolve(data);
    });
    });
    },
    [SAVE_SUPPORT](context, payload) {
        return new Promise((resolve, reject) => {
            ApiService.post(`${API.SAVE_SUPPORT}`, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [UPDATE_SUPPORT](context, payload) {
        console.log(payload)
        return new Promise((resolve, reject) => {
            ApiService.update(`${API.UPDATE_SUPPORT}`, payload.id, payload)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },
    [DELETE_SUPPORT](context, id) {
        return new Promise((resolve, reject) => {
            ApiService.delete(`${API.DELETE_SUPPORT}`, id)
                .then((data) => {
                    resolve(data)
                })
                .catch((err) => {
                    console.log(err)
                    reject(err);
                });
        });
    },

    [GET_DATA_SEARCH](context, payload) {
        return new Promise(resolve => {
            ApiService.query(API.GET_LIST_SUPPORT_SEARCH, payload).then(({ data }) => {
                if (data.status) {
                    context.commit(SET_DATA_SEARCH, data.data.supports);
                }
                resolve(data);
            });
        });
    },
};

const mutations = {
    [SET_LIST_SUPPORT](state, data) {
        state.supports = data.data;
    },
    [SET_DETAIL_SUPPORT](state, data) {
        state.support = data.data;
    },
    [SET_DATA_SEARCH](state, data) {
        state.dataSearchSupport = data
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};